import React from 'react'

function Footer(props) {
  const func =()=>{
    window.scrollTo(0,0); 
    console.log("dub")
}
  return (
    <div className="footer text-center d-flex"  onClick={(e) =>{ props.setDisplay('About'); func()}}>
        <p>
          Copyright  &copy; 2022 PolyA2z
        </p>
    </div>
  )
}

export default Footer;